import clevertap from "clevertap-web-sdk";
import { memo, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

// components
import Lisitng360View from "components/ListingNew/ListingNormal/Listing360View";
import ListingImageGalleryPage from "components/ListingNew/ListingNormal/ListingImageGalleryPage";
import ListingStories from "components/ListingNew/ListingNormal/ListingStories";

//helpers
import { getImgWithLogo } from "helpers/getCloudinaryImage";
import parseHTML from "helpers/parseHTML";

// custom hooks
import { useMediaQuery } from "customHooks/useMediaQuery";

// assets
import { SvgListingSignature } from "assets/icons/js/SvgListingSignature";
import { SvgPartnerHome } from "assets/icons/js/SvgPartnerHome";
import { SvgSignatureDiamondHome } from "assets/icons/js/SvgSignatureDiamondHome";
import { SvgSignatureHomeList } from "assets/icons/js/SvgSignatureHomeList";
import { SvgSignatureList } from "assets/icons/js/SvgSignatureList";

//scss
import "./style.scss";
import "react-lazy-load-image-component/src/effects/blur.css";
import { SvgNextLogo } from "assets/icons/js/SvgNextLogo";
import axios from "axios";
import { SvgMariottListing } from "assets/icons/js/SvgMariottListing";
import { useTheme } from "components/ListingNew/ListingTheme";
import Modal from "components/LoginAndRegister/Modal";
import { ReactComponent as View360Icon } from "assets/view360.svg";

interface image {
	ImgId: string;
	version: string;
	order: string;
}
interface PhotoGridProps {
	query?: URLSearchParams;
	images: image[];
	isVideoAvaiable?: boolean;
	className?: string;
	height?: string;
	width?: string;
	quality?: string;
	videos?: any;
	listName?: any;
	address?: any;
	isSignature?: boolean;
	video360?: string;
	isPartnerHome?: boolean;
	cancellation?: boolean;
	openSharePopup: () => void;
	isNext?: boolean;
	id?: String;
	guestImg: any;
	isMariott: any;
}

const PhotoGrid = memo(
	({
		query,
		images,
		isVideoAvaiable,
		className,
		height,
		width,
		quality,
		videos,
		listName,
		address,
		isSignature,
		video360,
		cancellation = false,
		isPartnerHome = false,
		isNext,
		openSharePopup,
		id,
		guestImg,
		isMariott,
	}: PhotoGridProps) => {
		const [searchParams, setSearchParams] = useSearchParams();
		const [openGallery, setOpenGallery] = useState(false);
		const [openStories, setOpenStories] = useState(false);
		const [open360View, setOpen360View] = useState(false);

		const [showSignatureDetails, setShowSignatureDetails] = useState(false);

		const openGalleryPage = () => {
			searchParams.set("photos", "true");
			setSearchParams(searchParams);
			setOpenGallery(true);
		};

		const closeGalleryPage = () => {
			searchParams.delete("photos");
			setSearchParams(searchParams);
			setOpenGallery(false);
			// eslint-disable-next-line no-restricted-globals
			history.go(-2);
		};

		useEffect(() => {
			// @ts-ignore
			if (query.get("photos") === "true") {
				setOpenGallery(true);
			}
			// @ts-ignore
			if (query.get("360-view") === "true") {
				setOpen360View(true);
			}
		}, [query]);

		const closeStories = () => {
			setOpenStories(false);
		};

		const open360ViewPage = () => {
			searchParams.set("360-view", "true");
			setSearchParams(searchParams);
			setOpen360View(true);
		};

		const close360ViewPage = () => {
			searchParams.delete("360-view");
			setSearchParams(searchParams);
			setOpen360View(false);
		};

		// mobile
		const mobileWidth = useMediaQuery();
		const isMobile = mobileWidth < 900;
		const phone = mobileWidth < 768;

		// const mobileSettings = {
		// 	dots: false,
		// 	infinite: true,
		// 	slidesToScroll: 1,
		// 	slidesToShow: 1,
		// 	arrows: false,
		// 	speed: 300,
		// 	centerMode: true,
		// 	centerPadding: "25px",
		// 	lazyLoad: "progressive",
		// };

		const monitorSettings = {
			dots: true,
			infinite: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			arrows: false,
			speed: 300,
			centerMode: true,
			centerPadding: "0px",
			lazyLoad: "progressive",
			cssEase: "linear",
			dotsClass: "slick-dots slick-thumb",
			customPaging: () => {
				return (
					<svg
						width="10"
						height="10"
						viewBox="0 0 10 10"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<circle cx="5" cy="5" r="4" stroke="white" strokeWidth="2" />
					</svg>
				);
			},
		};

		const theme = useTheme();

		return (
			<>
				{openGallery && (
					<ListingImageGalleryPage
						images={images}
						height={height}
						width={width}
						quality={quality}
						guestImages={guestImg}
						closeGalleryPage={closeGalleryPage}
						openSharePopup={openSharePopup}
						// listingId={id}
					/>
				)}
				{open360View && (
					<Modal shouldShow={open360View} onRequestClose={close360ViewPage}>
						<Lisitng360View
							close360ViewPage={close360ViewPage}
							openSharePopup={openSharePopup}
							video360={video360}
						/>
					</Modal>
				)}
				<ListingStories
					openStories={openStories}
					closeStories={closeStories}
					videos={videos}
				/>
				<div
					className={"photo-grid__wrapper " + className}
					onClick={() => {
						openGalleryPage();
					}}
				>
					<div className="listing-name-address-container">
						{isSignature ? (
							<>
								<button
									type="button"
									className="listing_signature-icon"
									onMouseEnter={() => setShowSignatureDetails(true)}
									onMouseLeave={() => setShowSignatureDetails(false)}
								>
									<SvgListingSignature />
									{showSignatureDetails && !isMobile ? (
										<span
											className="listing_signature-hover-container"
											style={{ zIndex: "10000" }}
										>
											<span className="listing_signature-hover-tri"></span>
											<p className="listing_signature-hover-heading">
												Signature homes
											</p>
											<p className="listing_signature-hover-sub-heading">
												Hand-picked elite vacation properties.
											</p>
											<span className="listing_signature-hover-wrapper no-top-border">
												<SvgSignatureDiamondHome />
												<p>Exclusive Ultra-Luxury properties.</p>
											</span>
											<span className="listing_signature-hover-wrapper">
												<SvgSignatureHomeList />
												<p>Extraordinary Signature amenities and services.</p>
											</span>
											<span className="listing_signature-hover-wrapper">
												<SvgSignatureList />
												<p>
													Specially curated food menus by our in-house chefs.
												</p>
											</span>
										</span>
									) : null}
								</button>
							</>
						) : null}
						{isNext ? <SvgNextLogo /> : ""}
						{theme?.name === "NEXT" && theme?.icon && (
							<img
								className="theme-logo"
								src={theme?.icon}
								style={{
									transform: "scale(0.9)",
									marginBottom: 20,
								}}
								alt="saffronstays theme logo"
							/>
						)}
						<h1
							className={
								isNext ? "next__listing__heading" : "normal__listing__heading"
							}
						>
							{parseHTML(listName)}
						</h1>
						<h3>{address}</h3>
						{theme?.name !== "NEXT" && theme?.icon && (
							<img
								className="theme-logo"
								src={theme?.icon}
								alt="saffronstays theme logo"
							/>
						)}
						{isMariott && (
							<div className="mariott__icon__container">
								<SvgMariottListing />
							</div>
						)}
						{video360 && !phone ? (
							<div className="video__play__wrapper">
								<div
									className="video__play__btn__container"
									style={{ paddingRight: 10, width: "fit-content" }}
									onClick={(e) => {
										e.stopPropagation();
										open360ViewPage();
									}}
								>
									<button
										className="video__play__btn"
										title="play listing stories"
										aria-label="play listing stories"
									>
										<div className="vr-icon">
											<View360Icon />
										</div>
										<p className="vid__text">View in AR</p>
									</button>
								</div>
							</div>
						) : isVideoAvaiable && !phone ? (
							<>
								<div className="video__play__wrapper">
									<div
										className="video__play__btn__container"
										onClick={(e) => {
											e.stopPropagation();
											clevertap.event.push("see360View_btn_listing_page", {
												location: window.location.pathname.split("/")[2],
												timestamp: new Date(),
											});
											setOpenStories(true);
										}}
									>
										<button
											className="video__play__btn"
											title="play listing stories"
											aria-label="play listing stories"
										>
											<span
												className="video__play__left"
												style={{
													backgroundImage: `url(https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:w-230,h-130,q-40/image/upload/${images[2]}.webp)`,
												}}
											>
												<svg
													width="14"
													height="17"
													viewBox="0 0 14 17"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M12.5921 7.64521C13.2335 8.03461 13.2335 8.96539 12.5921 9.35479L1.51898 16.0778C0.852556 16.4824 2.54178e-07 16.0026 2.88257e-07 15.223L8.75998e-07 1.77702C9.10077e-07 0.997389 0.852557 0.517623 1.51898 0.922236L12.5921 7.64521Z"
														fill="#ffffff"
													/>
												</svg>
											</span>
											<p className="vid__text">Play Video</p>
										</button>
									</div>
								</div>
							</>
						) : null}
					</div>
					{/* @ts-ignore */}
					<Slider {...monitorSettings}>
						{images.map((image, index) => {
							if (index < 5) {
								const src = getImgWithLogo({
									id: image,
									version: "1636374075",
									quality: quality ? quality : "40",
									height: height,
									width: width,
								});
								return (
									<LazyLoadImage
										src={src}
										alt={listName}
										effect="blur"
										key={index * Math.random() * 100}
										className="photo"
										visibleByDefault="true"
									/>
								);
							} else {
								return null;
							}
						})}
					</Slider>
					{video360 && phone ? (
						<div className="video__play__wrapper__mobile">
							<div
								className="video__play__btn__container"
								onClick={(e) => {
									e.stopPropagation();
									open360ViewPage();
								}}
							>
								<button
									className="video__play__btn"
									title="play listing stories"
									aria-label="play listing stories"
								>
									<div className="vr-icon">
										<View360Icon />
									</div>
								</button>
							</div>
						</div>
					) : isVideoAvaiable && phone ? (
						<>
							<div className="video__play__wrapper__mobile">
								<div
									className="video__play__btn__container"
									onClick={(e) => {
										e.stopPropagation();
										clevertap.event.push("see360View_btn_listing_page", {
											location: window.location.pathname.split("/")[2],
											timestamp: new Date(),
										});
										setOpenStories(true);
									}}
								>
									<button
										className="video__play__btn"
										title="play listing stories"
										aria-label="play listing stories"
									>
										<span
											className="video__play__left"
											style={{
												backgroundImage: `url(https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:w-230,h-130,q-40/image/upload/${images[2]}.webp)`,
											}}
										>
											<svg
												width="14"
												height="17"
												viewBox="0 0 14 17"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M12.5921 7.64521C13.2335 8.03461 13.2335 8.96539 12.5921 9.35479L1.51898 16.0778C0.852556 16.4824 2.54178e-07 16.0026 2.88257e-07 15.223L8.75998e-07 1.77702C9.10077e-07 0.997389 0.852557 0.517623 1.51898 0.922236L12.5921 7.64521Z"
													fill="#ffffff"
												/>
											</svg>
										</span>
										<p className="vid__text">Play Video</p>
									</button>
								</div>
							</div>
						</>
					) : null}
					{}
					<div>
						{/* {guestImg.length !== 0 && (
							<div
								className="photos_see_all-btn-container guest-gallery"
								style={{
									right: "calc(5% + 235px)",
								}}
							>
								<button
									aria-label="open gallery"
									className="text-xsm clr-black photos_see_all-btn"
									onClick={(e) => {
										e.stopPropagation();
										clevertap.event.push("seeAllGuestPhotos_btn_listing_page", {
											location: window.location.pathname.split("/")[2],
											timestamp: new Date(),
										});
									}}
									style={{
										//@ts-ignore
										backgroundImage: `url(https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:w-230,h-130,q-40/image/upload/${guestImg[0]?.VISUAL_MEDIA}.webp)`,
										backgroundColor: "black",
									}}
								></button>
								<p className="see__photos">See all Guest Photos</p>
							</div>
						)} */}
						<div className="photos_see_all-btn-container">
							<button
								aria-label="open gallery"
								className="text-xsm clr-black photos_see_all-btn"
								onClick={() => {
									clevertap.event.push("seeAllPhotos_btn_listing_page", {
										location: window.location.pathname.split("/")[2],
										timestamp: new Date(),
									});
								}}
								style={{
									backgroundImage: `url(https://ik.imagekit.io/5tgxhsqev/saffronstays-media/image/upload/${images[1]}?tr=w-230,h-130,q-40)`,
								}}
							></button>
							<p className="see__photos">See all {images.length} photos</p>
						</div>
					</div>
				</div>
			</>
		);
	},
);

export default PhotoGrid;
